const translation = {
  toVerifiedTip: {
    coupon: 'کوپن انحصاری ۱۰۰٪',
    end: 'برای طرح حرفه‌ای دیفی.',
    front: 'شما اکنون برای وضعیت تأیید شده آموزشی واجد شرایط هستید. لطفاً اطلاعات تحصیلی خود را در زیر وارد کنید تا فرآیند را کامل کرده و یک دریافت کنید.',
  },
  form: {
    schoolName: {
      title: 'نام مدرسه شما',
      placeholder: 'نام رسمی و کامل مدرسه خود را وارد کنید',
    },
    schoolRole: {
      option: {
        teacher: 'معلم',
        student: 'دانش آموز',
        administrator: 'مدیر مدرسه',
      },
      title: 'نقش شما در مدرسه',
    },
    terms: {
      desc: {
        privacyPolicy: 'سیاست حریم خصوصی',
        end: 'با ارسال:',
        and: 'و',
        termsOfService: 'شرایط خدمات',
        front: 'اطلاعات شما و استفاده از وضعیت تأیید شده آموزشی تابع شرایط ما است.',
      },
      option: {
        age: 'من تأیید می‌کنم که حداقل ۱۸ سال سن دارم',
        inSchool: 'من تأیید می‌کنم که در مؤسسه‌ای که نام برده شده، ثبت‌نام شده یا استخدام شده‌ام. دیفی ممکن است از من بخواهد مدرکی برای ثبت‌نام/استخدام ارائه دهم. اگر صلاحیتم را اشتباه نمایم، موافقت می‌کنم که هر گونه هزینه‌ای که به‌خاطر وضعیت تحصیلی من ابتدا معاف شده، پرداخت کنم.',
      },
      title: 'شرایط و توافقات',
    },
  },
  submitError: 'ارسال فرم ناموفق بود. لطفا بعداً دوباره تلاش کنید.',
  emailLabel: 'ایمیل فعلی شما',
  currentSigned: 'اکنون به عنوان',
  rejectContent: 'متاسفانه، شما واجد شرایط وضعیت تأیید شده آموزشی نیستید و به همین دلیل نمی‌توانید کوپن انحصاری ۱۰۰٪ برای طرح حرفه‌ای Dify را در صورت استفاده از این آدرس ایمیل دریافت کنید.',
  learn: 'یاد بگیرید چگونه مدارک تحصیلی خود را تأیید کنید',
  successContent: 'ما یک کوپن تخفیف ۱۰۰٪ برای طرح حرفه‌ای Dify به حساب شما صادر کرده‌ایم. این کوپن به مدت یک سال اعتبار دارد، لطفاً در بازه اعتبار از آن استفاده کنید.',
  toVerified: 'تحصیلات خود را تأیید کنید',
  rejectTitle: 'تأییدیه آموزشی دیفی شما رد شده است',
  submit: 'ارسال',
  successTitle: 'شما آموزش دیفی تأیید شده دارید',
}

export default translation
